import React from 'react';
import { Page, PageHeader, PageBody } from "../base/Page";
import { browserHistory } from "react-router";
import { Button, Row, Col, Panel, FormGroup, FormControl, ControlLabel, Modal } from 'react-bootstrap';
import API from "../base/API";
import Auth from "../auth/Auth";
import DataSelectTable from "../base/DataSelectTable";
import { translate } from '../base/Translation';

export default class BranchNew extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			save_branch: "/branch/save/new",
			get_branch: "/branch/fetch/:branch",
			get_brands: "/brand/fetch/all",
			get_clients: "/user/fetch/by/role/:role",
			get_branch_users: "/user/fetch/by/role/:role/by/brand/:brand",
		});

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			showModal: false,
			branch: {
				id: 0,
				name: translate("Nová prevádzka"),
				identifier: "",
				brand: { id: 0, name: "" },
				address: "",
				city: "",
				business_id: "",
				vat_number: "",
				tax_id: "",
				iban: "",
				users: [],
				subscribers: []
			},
			brands: [],
			branch_users: [],
			tableColumns: [
				{ name: "select", display: "#", sort: true, width: 5 },
				{ name: "name", display: translate("Názov"), sort: true, width: 20 },
				{ name: "surname", display: translate("Priezvisko"), sort: true, width: 20 },
				{ name: "email", display: translate("E-Mail"), sort: true, width: 55 },
			]
		};
	}


	saveData() {
		this.api.request({
			route: "save_branch",
			data: this.state.branch,
			created: (response) => {
				browserHistory.push("/branches");
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	fetchData() {
		this.api.request({
			route: "get_brands",
			success: (response) => {
				this.setState({ brands: response });
			}
		});
		this.api.request({
			route: "get_branch_users",
			params: { role: 2 },
			success: (response) => {
				this.setState({ branch_users: response });
			}
		});
	}

	fetchUsers(brand = false) {
		this.api.request({
			route: "get_branch_users",
			params: { role: 2, brand: brand ? brand : this.state.branch.brand.id },
			success: (response) => {
				this.setState({ branch_users: response });
			}
		});
	}

	onBranchChange(evt) {
		// Get data from state
		let newBranch = this.state.branch;

		if (evt.target.name !== "brand") {
			// Update it's value
			newBranch[evt.target.name] = evt.target.value;
		} else {
			newBranch[evt.target.name]["id"] = evt.target.value;
			newBranch.users = [];
			this.fetchUsers(evt.target.value);
		}


		// Update data in state
		this.setState({ branch: newBranch });
	}

	onBranchSave(evt) {
		this.saveData();
	}

	onTableSelect(index, selected) {
		let branch = this.state.branch;

		branch.users = selected;

		this.setState({ branch });
	}

	handleClose() {
		this.setState({ showModal: false });
	}

	handleShow() {
		this.setState({ showModal: true });
	}

	/*
	*
	* Render methods
	*
	*/
	renderOptions(data) {
		let options = data.map(function (item) {
			return (
				<option value={item.id} key={item.id}>{typeof item.name !== "undefined" ? item.name : item.email}</option>
			)
		});

		return (options);
	}

	render() {

		if (this.state.branch === null) {
			return (
				<Page>
					<PageHeader>{translate("Prosím počkajte")}</PageHeader>
					<PageBody>{translate("Obsah sa načítava")}</PageBody>
				</Page>
			)
		}

		return (
			<Page>
				<PageHeader title={translate("Pridať novú prevádzku")} />
				<PageBody>
					<Row>
						<Col lg={6}>
							<Panel header={translate("Základné")}>
								<FormGroup>
									<ControlLabel>{translate("Kód prevádzky")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.identifier} name="identifier" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Názov")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.name} name="name" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Konkurenčná")}</ControlLabel>
									<FormControl componentClass="select" name="competitive" defaultValue={this.state.branch.competitive}
										onChange={this.onBranchChange.bind(this)}>
										<option value={0}>{translate("Nie")}</option>
										<option value={1}>{translate("Áno")}</option>
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Značka")}</ControlLabel>
									<FormControl componentClass="select" name="brand" defaultValue={this.state.branch.brand.id}
										onChange={this.onBranchChange.bind(this)}>
										<option value={0}>{translate("Vyberte")}</option>
										{this.renderOptions(this.state.brands)}
									</FormControl>
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Adresa")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.address} name="address" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("Obec")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.city} name="city" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Rozšírené")}>
								<FormGroup>
									<ControlLabel>{translate("IČO")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.business_id} name="business_id" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("IČ-DPH")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.vat_number} name="vat_number" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("DIČ")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.tax_id} name="tax_id" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
								<FormGroup>
									<ControlLabel>{translate("IBAN")}</ControlLabel>
									<FormControl defaultValue={this.state.branch.iban} name="iban" onChange={this.onBranchChange.bind(this)} />
								</FormGroup>
							</Panel>
						</Col>
					</Row>
					<Row style={{display: parseInt(this.state.branch.competitive, 10) !== 1 ? "inherit" : "none"}}>
						<Col lg={6}>
						<Panel header={translate("Používatelia")}>
								<table className="table table-responsive table-hover table-striped" style={{ marginBottom: "1rem" }}>
									<thead>
										<tr>
											<th style={{ width: "33.3333%" }}>{translate("Meno")}</th>
											<th style={{ width: "33.3333%" }}>{translate("E-mail")}</th>
											<th style={{ width: "33.3333%", textAlign: "right" }}>{translate("Možnosti")}</th>
										</tr>
									</thead>
									<tbody>
										{this.state.branch.users.length > 0 ? this.state.branch.users.map(function (user, index) {

											user = this.state.branch_users.find((u) => {
												return u.id === user.id;
											});

											if (!user) {
												return;
											}

											return (
												<tr key={"sub_" + index}>
													<td>
														{user.name + " " + user.surname}
													</td>
													<td>
														{user.email}
													</td>
													<td style={{ textAlign: "right" }}>
														<button className="btn btn-danger" onClick={(e) => {
															let branch = this.state.branch;

															const index = branch.users.findIndex(function (u) {
																return u.id === this;
															}.bind(user.id));

															if (index > -1) {
																branch.users.splice(index, 1);
															}

															this.setState({ branch });

														}}><i className="fa fa-trash" /></button>
													</td>
												</tr>
											)
										}.bind(this)) : <tr><td colSpan={3}>{translate("Nie je čo zobraziť.")}</td></tr>}
									</tbody>
								</table>
								<Row>
									<Col md={12}>
										<button className="btn btn-success pull-right" onClick={this.handleShow.bind(this)}>{translate("Pridať")}</button>
									</Col>
								</Row>
								<Modal show={this.state.showModal} onHide={this.handleClose}>
									<Modal.Header closeButton>
										<Modal.Title>{translate("Výber používateľov")}</Modal.Title>
									</Modal.Header>
									<Modal.Body>
										<DataSelectTable
											tableColumns={this.state.tableColumns}
											data={this.state.branch_users}
											selected={this.state.branch.users}
											onChange={this.onTableSelect.bind(this)} />
									</Modal.Body>
									<Modal.Footer>
										<Button onClick={this.handleClose}>{translate("Zatvoriť")}</Button>
									</Modal.Footer>
								</Modal>
							</Panel>
						</Col>
						<Col lg={6}>
							<Panel header={translate("Notifikácia")}>
								{this.state.branch.subscribers.map(function (sub, index) {
									return (
										<div className="row" key={"sub_" + index}>
											<div className="col-md-3">
												<div className="form-group">
													<input type="text" defaultValue={sub.name} placeholder={translate("Názov")} className="form-control" />
												</div>
											</div>
											<div className="col-md-4">
												<div className="form-group">
													<input type="text" defaultValue={sub.email} placeholder={translate("E-Mail")} className="form-control" />
												</div>
											</div>
											<div className="col-md-3">
												<div className="form-group">
													<input type="text" defaultValue={sub.phone} placeholder={translate("Telefón")} className="form-control" />
												</div>
											</div>
											<div className="col-md-2">
												<div className="form-group">
													<button className="btn btn-danger" onClick={(e) => {
														let branch = this.state.branch;

														const index = branch.subscribers.findIndex(function (s) {
															return s.email === this;
														}.bind(sub.email));

														if (index > -1) {
															branch.subscribers.splice(index, 1);
														}

														this.setState({ branch });

													}}><i className="fa fa-trash" /></button>
												</div>
											</div>
										</div>
									)
								}.bind(this))}
								<div className="row">
									<div className="col-md-3">
										<div className="form-group">
											<input type="text" defaultValue="" className="form-control" placeholder={translate("Názov")} ref={(input) => { this.sub_name = input }} />
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<input type="text" defaultValue="" className="form-control" placeholder={translate("E-Mail")} ref={(input) => { this.sub_email = input }} />
										</div>
									</div>
									<div className="col-md-3">
										<div className="form-group">
											<input type="text" defaultValue="" className="form-control" placeholder={translate("Telefón")} ref={(input) => { this.sub_phone = input }} />
										</div>
									</div>
									<div className="col-md-2">
										<div className="form-group">
											<button className="btn btn-success" onClick={(e) => {
												let branch = this.state.branch;

												branch.subscribers.push({
													name: this.sub_name.value,
													email: this.sub_email.value,
													phone: this.sub_phone.value
												});

												this.sub_name.value = "";
												this.sub_email.value = "";
												this.sub_phone.value = "";

												this.setState({ branch });

											}}>{translate("Pridať")}</button>
										</div>
									</div>
								</div>
							</Panel>
						</Col>
					</Row>
					<Row>
						<Col lg={12}>
							<FormGroup>
								<Button bsStyle="success" onClick={this.onBranchSave.bind(this)}>{translate("Uložiť")}</Button>
							</FormGroup>
						</Col>
					</Row>
				</PageBody>
			</Page>
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/branch/BranchNew.js